import {
    SET_USER,
    LOGIN_USER,
    LOGOUT_USER,
    CHANGE_LOADING,
    LOGIN_USER_ERROR,
    SET_SESSION_USER,
    LOGIN_USER_SUCCESS,
    LOGGED_IN_USER,
    SET_REFRESH_USER,
    REFRESH_USER,
} from '../actions';

export const setSession = sessionId => ({
    type: SET_SESSION_USER,
    payload: { sessionId },
});

export const loginUser = (body, history, onSuccess) => ({
    type: LOGIN_USER,
    payload: { body, history, onSuccess },
});

export const sagaGetUser = (history, token) => ({
    type: LOGGED_IN_USER,
    payload: { history, token },
});

export const loginUserSuccess = (token, user) => ({
    type: LOGIN_USER_SUCCESS,
    payload: { token: token, user: user },
});

export const changeLoading = loading => ({
    type: CHANGE_LOADING,
    payload: { loading },
});

export const loginUserError = message => ({
    type: LOGIN_USER_ERROR,
    payload: { message },
});

export const setUser = user => ({
    type: SET_USER,
    payload: { user },
});

export const logoutUser = history => ({
    type: LOGOUT_USER,
    payload: { history },
});

export const setRefreshUser = user => ({
    type: SET_REFRESH_USER,
    payload: user,
});

export const refreshUser = () => ({
    type: REFRESH_USER
});
